export function getItemsFromFolder(applicationPaths, folder) {
  return applicationPaths
    .filter(el => el.path.startsWith(folder) && el.meta)
    .map(({meta, path, text, icon}) => ({
      text: text != null ? text : meta.text,
      to: path,
      icon: icon != null ? icon : meta.icon,
      module: meta.module || '',
      meta,
    }))
}

export function getItemsFromFolderAndMarket(applicationPaths, folder, market) {
  return getItemsFromFolder(applicationPaths, folder).filter(
    item => item.module == market || (item.meta.markets && item.meta.markets[market] != null),
  )
}

export const folderIcons = {
  LIST: 'view_list',
  REPORT: 'dashboard',
  'MONTH END': 'insert_invitation',
  CONFIG: 'build',
  CLIENT: 'fa-address-card',
  SECURITY: 'security',
  MARKETDATA: 'timeline',
  PROCESS: 'fas fa-cog',
}
